import * as React from 'react';
export const ToastContext = React.createContext<{
  ref:
    | {
        current: HTMLElement | null | undefined;
      }
    | null
    | undefined;
}>({
  ref: null,
});
